export default "__VITE_ASSET__DM74VRat__"